module.controller('subaccountSearchCtrl', ['$scope', '$http', 'memberService', 'baseURI', 'OVERLAY', function($scope,$http, memberService, baseURI, OVERLAY){
  var searchUrl = baseURI + 'cardholder/search/';
  $scope.overlay = OVERLAY['member.home.retrieve'];
  $scope.searchResult = [];
  $scope.loading = true;

  var getSubs = function(){
    var url = baseURI + 'card/sub-cards';
    $http.get(url, {cache: true}).then(function (resp){
      $scope.searchResult = resp.data.Data || [];
      $scope.loading = true;
    }).catch(function (error){
      $scope.loading = false;
      console.log('err', error);
    });
  };

  getSubs();

}]);
